import React, { createContext, useContext, useMemo, useCallback } from 'react'
import { useTimeTravel } from './QualityAssuranceProviders/TimeTravelProvider'
import { conferenceConfig, registrationConfig } from '../config/experience'

const SEPTEMBER = 8 // JavaScript months are 0-indexed, so September is 8

interface ConferenceContextValue {
  getConferenceYear: () => string
}

const ConferenceContext = createContext<ConferenceContextValue>({
  getConferenceYear: () => conferenceConfig.startYear,
})
export const useConferenceContext = (): ConferenceContextValue => useContext(ConferenceContext)

export const ConferenceProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const { getNow } = useTimeTravel()
  const registrationYear = new Date(registrationConfig.starts).getFullYear()
  const conferenceYear = new Date(conferenceConfig.starts).getFullYear()
  const currentDate = new Date(getNow())
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()

  const getConferenceYear = useCallback(() => {
    // Configs will have already been rolled forward for the next cycle by the time the prior conference ends.
    // If current year is > registration.start year or the current month is before September, this is the current year. Otherwise, it is the conference.start year.
    return `${currentYear > registrationYear || currentMonth < SEPTEMBER ? currentYear : conferenceYear}`
  }, [currentYear, currentMonth, registrationYear, conferenceYear])

  const value = useMemo(() => ({ getConferenceYear }), [getConferenceYear])

  return <ConferenceContext.Provider value={value}>{children}</ConferenceContext.Provider>
}
